
export const AnimateHack = {
    animate: true,
}